import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as appConstants from '../../../constants/appConstants';
import * as userDataHelper from '../../../helpers/userDataHelper';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';

class CharacterSpeak extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            character_name: appHelper.getScreenCharacterNameByAssetId(this.props.asset_id),
            screen: appHelper.getScreenByAssetId(this.props.asset_id),
            locale: appHelper.getLocalData(this.props.dialog),
            asset: {
                src: ""
            },

            character: {
                src: "",
                pose: "",
                position: ""
            },
            audio:{
                src:""
            },
            option:{},
            hasAudio: false,
            readyAudio: false,
            audioComplete: false,
            renderComplete: false,
            character_speech_bubble_label: appHelper.getLocaleString("character_speech_bubble_label"),
            character_label: appHelper.getLocaleString("character_label"),
            speaking_label: appHelper.getLocaleString("speaking_label")
        };

        this.showResponse = this.showResponse.bind(this);
        this.handleProgression = this.handleProgression.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.getClass = this.getClass.bind(this);
        this.getExpressionClass = this.getExpressionClass.bind(this);
        this.onPlayAudio = this.onPlayAudio.bind(this);
        this.onEndAudio = this.onEndAudio.bind(this);
    }

    componentDidMount() {
        this.getAssets();
        this.showResponse();
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.props.dialog),
                character_speech_bubble_label: appHelper.getLocaleString("character_speech_bubble_label"),
                character_label: appHelper.getLocaleString("character_label"),
                speaking_label: appHelper.getLocaleString("speaking_label")
            });
        }
    }

    componentDidUpdate(){
        if(this.state.readyAudio){
            this.onPlayAudio();
        }

        if(this.state.hasAudio && this.state.audioComplete && this.state.renderComplete){
            this.handleProgression();
        }
    }

    getAssets() {
        let screenCharacter = {};
        let characterAsset  = Object.assign(this.state.character);
        let option = {};

        if (appHelper.isDefined(this.state.screen.assets.character)){
            screenCharacter = appHelper.getCharacterAsset(this.state.screen.assets.character);
            characterAsset = appHelper.getCharacterPose(screenCharacter,this.state.screen.assets.character);
        }

        if(appHelper.isDefined(this.props.asset_id)){
            let asset = appHelper.getArrayObjectByKey(this.state.screen.objects,"asset_id",this.props.asset_id);
            if(appHelper.isDefined(asset.character_pose) && asset.character_pose.pose !== objectConstants.INHERIT){
                characterAsset = appHelper.getCharacterPose(screenCharacter, asset.character_pose);
                if(!appHelper.isDefined(characterAsset.position)){
                    characterAsset = Object.assign({},characterAsset, {position: screenCharacter.position});
                }
            }

            if(appHelper.isDefined(this.props.option_id)) {
                option = Object.assign({},appHelper.getArrayObjectByKey(asset.options, "option_id", this.props.option_id));
                if (appHelper.isDefined(option.character_pose)  && option.character_pose.pose !== objectConstants.INHERIT) {
                    characterAsset = appHelper.getCharacterPose(screenCharacter, option.character_pose);
                    if(!appHelper.isDefined(characterAsset.position)){
                        characterAsset = Object.assign({},characterAsset, {position: screenCharacter.position});
                    }
                }
            }
        }

        if(appHelper.isDefined(characterAsset.src)){
            this.setState({
                character: Object.assign({},characterAsset),
                option: Object.assign({},option)
            });
        }


        if (appHelper.isDefined(this.props.dialog.image)) {
            this.setState({
                asset: Object.assign({}, appHelper.getLibraryImageAsset(this.props.dialog.image)),
            });
        }

        if(appHelper.isDefined(this.props.dialog.audio)){
            this.setState({
                audio: Object.assign({}, appHelper.getAudioAsset(this.props.dialog.audio)),
                readyAudio: true,
                hasAudio: true,
            });

        }
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    showResponse() {
        let objectRef = this.refs[`characterSpeak_${this.props.index}`];
        TweenLite.set(objectRef, {height: "auto"});
        TweenLite.from(objectRef, objectConstants.SPEECH_BUBBLE_DURATION, {
            height: 0,
            ease: Expo.easeInOut,
            delay: this.props.delay
        }).eventCallback("onComplete", this.onComplete);
    }

    onComplete() {
        this.setState({renderComplete: true});
        if(!this.state.hasAudio){
            this.handleProgression();
        }
    }

    onPlayAudio(){
        this.setState({
            readyAudio: false
        });

        let videoRef = this.refs[`learnerSpeak_${this.props.asset_id}_${this.props.index}_audio`];
        if(appHelper.isDefined(videoRef)){
            videoRef.play();
            let onEndAudio = this.onEndAudio;
            videoRef.onended = function(){
                onEndAudio();
            };
        }
    }

    onEndAudio(){
        this.setState({
            audioComplete: true
        });
    }

    handleProgression() {
        this.setState({renderComplete: false, audioComplete: false});
        this.props.callbacks.onObjectComplete(this.props.index);
    }

    getClass(){
        return appHelper.isDefined(this.state.character.src) && this.state.character.src.length > 0 ? 'customer-has-expression' : '';
    }

    getExpressionClass(){
        return appHelper.isDefined(this.state.option.result) ? this.state.option.result : '';
    }

    render() {
        return (
            <span>
            <div className={`object-container ${this.getClass()}`} ref={`characterSpeak_${this.props.index}`}>
                <div className="customer_name_label">
                    <span className="hidden-el">{this.state.character_speech_bubble_label}, </span>
                    {appHelper.isDefined(this.state.character_name) && this.state.character_name !== null && this.state.character_name.length > 0
                        ?
                        <span>{this.state.character_name}</span>
                        :
                        <span>{this.state.character_label}</span>
                    }
                    <span className="hidden-el">{this.state.speaking_label},</span>
                </div>
                {appHelper.isDefined(this.state.character.src) && this.state.character.src.length > 0
                    ?
                        <div className={`character-expression ${this.getExpressionClass()} ${this.state.character.position}`}>
                            <img src={this.getImagePath(this.state.character.src)} alt=""/>
                        </div>
                    :
                    null
                }
                {
                    appHelper.isDefined(this.state.locale.label)
                        ?
                        <div className={`character speak`} dangerouslySetInnerHTML={{__html: this.state.locale.label}}/>
                        :
                        <div className={`character-conversation-image`}>
                            <img src={this.getImagePath(this.state.asset.src)} alt=""/>
                        </div>
                }



            </div>
                {appHelper.isDefined(this.state.audio.src) && this.state.audio.src.length > 0
                    ?
                    <audio ref={`learnerSpeak_${this.props.asset_id}_${this.props.index}_audio`} src={this.getImagePath(this.state.audio.src)} />
                    :
                    null
                }
            </span>

        );
    }
}

CharacterSpeak.propTypes = {
    asset_id: PropTypes.number.isRequired,
    option_id: PropTypes.number,
    index: PropTypes.number.isRequired,
    dialog: PropTypes.object.isRequired,
    delay: PropTypes.number.isRequired,
    callbacks: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object
};

CharacterSpeak.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CharacterSpeak);



/** WEBPACK FOOTER **
 ** ./src/components/objects/conversationDialog/CharacterSpeak.js
 **/